

import React, {Component} from 'react'
import IdleTimer from 'react-idle-timer'

var logger = require('../../utils/logger/logger');
var controlSettingsUtils = require('../../utils/domain/settings/controlSettingsUtils');
var displaySettingsUtils = require('../../utils/domain/settings/displaySettingsUtils');
var stateManager = require('../../utils/state/stateManager.js');
var staffLoginAction = require('../../utils/state/actions/staffLogin/staffLoginAction.js');
var screenSaverAction = require('../../utils/state/actions/views/screenSaver/screenSaverAction');



const saleTimeoutInMilliseconds = 1000 * 60 * 5;    //5 minutes

class IdleTimerComponent extends Component 
{
    constructor(props)
    {
        super(props)
        this.idleTimer = React.createRef()
    }

    _onIdle = (e) => 
    {
        try
        {
            if (!stateManager.getStore().getState().applicationInitialized ||
                stateManager.getStore().getState().saleContext != null ||
                stateManager.getStore().getState().internetConnectionDisconnected ||
                stateManager.getStore().getState().internetConnectionSuspended ||
                (
                    this.props.alertDialogue != null &&
                    (this.props.alertDialogue.type == "user.notification" || this.props.alertDialogue.type == "cli.notification")
                )
                )
            {
                this.idleTimer.current.reset();
                return;
            }
            
            if (controlSettingsUtils.getLogoutAfterIdle())
                stateManager.getStore().dispatch(staffLoginAction.createAction(null));
       
            if (displaySettingsUtils.getDisplayScreenSaver())
                stateManager.getStore().dispatch(screenSaverAction.createAction(true));
        }
        catch(error)
        {
            logger.error(`Error occurred while handling onIdle callback. ${error}`, {}, error);
        }
        
    }

    _onActive = () =>
    {
        try
        {
            stateManager.getStore().dispatch(screenSaverAction.createAction(false));
        }
        catch(error)
        {
            logger.error(`Error occurred while handling onActive callback. ${error}`, {}, error);
        }
        
    }

    render()
    {
        return <IdleTimer
                    key='idleTimer'
                    startOnMount={ true }
                    ref={ this.idleTimer }
                    element={ document }
                    onIdle={ this._onIdle }
                    onActive={this._onActive}
                    timeout={ saleTimeoutInMilliseconds }
                />
    }
}


export default IdleTimerComponent;